import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {
    ExchangeRate,
     ExchangeRatesQuery,
    useExchangeRatesMutationMutation,
    useExchangeRatesQuery
} from "../../generated/graphql";
import {CurrencySelect} from "../../components/MaterialSelects/CurrencySelect";
import {NumberField} from "../../components/number-input";
import { useToast } from "../../contexts/toast";
import {useLocation} from "react-router";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import {uniqueId} from "../../utils";

const columns:FieldTableColumnProps<ExchangeRate>[] = [{
    header: 'From',
    accessor: 'from',
    dataType: 'select',
    options: {
        label:'label',
//        renderer:({field})=>(field.value?.label??''),
        // eslint-disable-next-line react/prop-types, react/display-name
        renderEditor: ({field}) => <CurrencySelect {...field} autoFocus={true} />
    }
},{
    header: 'To',
    accessor: 'to',
    dataType:'select',
    options: {
        label:'label',
        // eslint-disable-next-line react/prop-types, react/display-name
        renderEditor: ({field}) => <CurrencySelect {...field} autoFocus={true}/>
    }
},{
    header: 'Rate',
    accessor: 'rate',
    dataType:'number',
    // eslint-disable-next-line react/prop-types, react/display-name
    options: {
        renderEditor: ({field}) => <NumberField {...field} autoFocus={true}/>
    }
}
];

const relationships = {
    from:'connect',
    to:'connect'
};

function newRow():ExchangeRate {
    return {
        id: uniqueId(),
        from: null,
        to: null,
        rate: 1
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'from': yup.object().required(),
        'to': yup.object().required(),
        'rate': yup.number().required()
    })
);

function getValues(data:ExchangeRatesQuery):ExchangeRate[] {
    return data?.exchangeRates;
}

const ExchangeRates = ()=> {
    const { toast, dismiss } = useToast();

    const query = useExchangeRatesQuery();
    const [mutation,mutationResult] = useExchangeRatesMutationMutation();
    const url = useLocation().pathname;
    const onBeforeSubmit = ({values})=>{
        const duplicateTextERs = {};
        let failed = false;
        values.forEach((v)=>{
            if(duplicateTextERs[v.from?.id+':'+v.to?.id]) {
                failed = true;
            }
            duplicateTextERs[v.from?.id+':'+v.to?.id] = 1;
        });
        if(failed) {
            toast('Duplicate exchange rates are not permitted',{id:'ER_SAVE',variant:'error'});
            return false;
        }
        return true;
    };
    return (
        <ListEditor
            relationships={relationships}
            columns={columns}
            validationSchema={schema}
            onBeforeSubmit={onBeforeSubmit}
            title="Exchange Rates"
            query={query}
            getValues={getValues}
            mutation={mutation}
            saveResult={mutationResult}
            permission="exchangerates"
            newRow={newRow}
            newRowLabel="Add Exchange Rate"
         baseUrl={url}
        className="exchange-rates"
        />);
}

export default ExchangeRates;
